import styled from 'styled-components'

import { Button } from 'components/Button'
import { SvgImage } from 'components/SvgImage'

import { Color } from 'root-constants'

export const BreakScreenButton = styled(Button)`
  height: 48px;

  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  background-color: ${Color.INK_DARKEST};
  color: ${Color.GOLD_LIGHTER};
`

export const StyledBreakScreenLayout = {
  Wrapper: styled.div`
    position: relative;
    width: 100%;
    max-width: 375px;
    min-height: 100%;

    display: flex;
    align-items: center;
    flex-direction: column;
    overflow: hidden;

    padding: 0 24px 24px;
    margin: 0 auto;
  `,
  BackgroundCells: styled(SvgImage)`
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    pointer-events: none;
  `,
  Content: styled.div`
    position: relative;
    width: 100%;
    min-height: 0;

    display: flex;
    align-items: center;
    flex-direction: column;
    flex-grow: 1;
  `,
}
